import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords do not match.");
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-sm" data-testid="reset-password-page">
        <h1 className="font-heading text-2xl font-bold text-slate-900">Choose a new password</h1>
        {!token ? (
          <p className="mt-4 text-sm text-rose-600" data-testid="reset-missing-token">This reset link is incomplete. <Link to="/forgot-password" className="underline">Request a new one</Link>.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div>
              <Label htmlFor="rp-password">New password</Label>
              <PasswordInput id="rp-password" minLength={6} data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required wrapperClassName="mt-1.5" className="h-11" />
            </div>
            <div>
              <Label htmlFor="rp-confirm">Confirm new password</Label>
              <PasswordInput id="rp-confirm" minLength={6} data-testid="reset-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required wrapperClassName="mt-1.5" className="h-11" />
            </div>
            {error && <div className="text-sm text-rose-600" data-testid="reset-error">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full h-11 rounded-full bg-slate-900 hover:bg-black text-white" data-testid="reset-submit">
              {loading ? "Saving..." : "Update password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
